import { AxiosResponse } from 'axios';
import api from './api';
import { Selection } from '../components/dashboard/selection';
import { CLocation, toString } from '../types/location';
import { Point } from 'pigeon-maps';

function patch(selected: Selection): string {
    // prettier-ignore
    switch (selected.kind){
        case 'node'     : return `/location/all/${selected.nodeId}`;
        case 'location' : return `/location/all/${selected.nodeId}`;
        case 'device'   : return `/location/all/${selected.nodeId}`;
        case 'kosa'     : return `/location/kosa/${selected.kosaId}`;
    }
}

//=================================================================================================
export class PositionService {
    static async getPositions(selected: Selection): Promise<AxiosResponse> {
        return api.get(patch(selected));
    }

    static async getByNode(nodeId: number): Promise<AxiosResponse> {
        return api.get(`/location/${nodeId}`);
    }

    static async create(location: CLocation): Promise<AxiosResponse> {
        const loc = { ...location, coordinates: toString(location.coordinates) };
        return api.put('/location', loc);
    }

    static async deleteByNode(nodeId: number): Promise<AxiosResponse> {
        return api.delete(`/location/${nodeId}`);
    }

    static async addressHint(address: string): Promise<AxiosResponse> {
        return api.post('location/address', { address: address });
    }

    static async pointToAddress(point: Point): Promise<AxiosResponse> {
        return api.post('location/point', point);
    }
}
